export const testIfLocationIsInSingapore = (location: [number, number]) => {
  const singaporeCenter = [1.3521, 103.8198];

  const distance =
    (location[0] - singaporeCenter[0]) * (location[0] - singaporeCenter[0]) +
    (location[1] - singaporeCenter[1]) * (location[1] - singaporeCenter[1]);
  return distance < 0.035;
};
